import { Link, useLocation } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const Navbar = ({ variant = 'dark' }) => {
  const location = useLocation();
  const isDark = variant === 'dark';
  const linkColor = isDark ? 'text-tl-textSecondaryOnDark hover:text-white' : 'text-slate-700 hover:text-slate-900';

  return (
    <nav
      data-testid="landing-nav"
      className={`relative z-20 flex items-center justify-between px-4 sm:px-6 lg:px-8 py-4 max-w-6xl mx-auto`}
    >
      <Link to="/" data-testid="nav-logo" className={`flex items-center gap-2 font-medium text-[15px] ${isDark ? 'text-white' : 'text-slate-900'}`}>
        <Sparkles className="h-5 w-5 text-tl-gold" strokeWidth={2} />
        <span>TalesLore</span>
      </Link>

      <div className="hidden md:flex items-center gap-6">
        <a href="/#how" className={`text-[13px] ${linkColor}`}>How it works</a>
        <a href="/#mythologies" className={`text-[13px] ${linkColor}`}>Mythologies</a>
        <a href="/#pricing" className={`text-[13px] ${linkColor}`}>Pricing</a>
      </div>

      <Link to="/create" data-testid="landing-nav-create-button">
        <Button className="h-10 bg-tl-purple hover:bg-tl-purpleDark text-white text-[13px] px-4">
          Create free story
        </Button>
      </Link>
    </nav>
  );
};
